// Mirror of the API's SPORT_KEYS / SURFACE_KEYS / SPORT_SURFACES. Keep in sync
// with apps/api/src/lib/validators.ts — the API rejects anything outside this
// list. No shared package between admin and web, hence the duplication.

export const SPORT_KEYS = [
  "TENNIS",
  "PADEL",
  "BASKETBALL",
  "FOOTBALL",
  "VOLLEYBALL",
  "SQUASH",
  "TABLE_TENNIS",
  "BADMINTON",
  "HANDBALL",
  "PICKLEBALL",
] as const;
export type SportKey = (typeof SPORT_KEYS)[number];

export const SURFACE_KEYS = [
  "CLAY",
  "HARD",
  "CONCRETE",
  "ASPHALT",
  "GRASS",
  "NATURAL_GRASS",
  "ARTIFICIAL_GRASS",
  "CARPET",
  "PARQUET",
  "RUBBER",
  "SAND",
  "SYNTHETIC",
  "MAT",
] as const;
export type SurfaceKey = (typeof SURFACE_KEYS)[number];

export const SPORT_SURFACES: Record<SportKey, readonly SurfaceKey[]> = {
  TENNIS: ["CLAY", "HARD", "CONCRETE", "GRASS", "CARPET", "ARTIFICIAL_GRASS"],
  PADEL: [],
  BASKETBALL: ["PARQUET", "CONCRETE", "ASPHALT", "RUBBER"],
  FOOTBALL: ["NATURAL_GRASS", "ARTIFICIAL_GRASS", "CONCRETE", "PARQUET"],
  VOLLEYBALL: ["SAND", "PARQUET", "SYNTHETIC", "CONCRETE"],
  SQUASH: [],
  TABLE_TENNIS: [],
  BADMINTON: ["PARQUET", "SYNTHETIC", "MAT"],
  HANDBALL: ["PARQUET", "SYNTHETIC", "CONCRETE"],
  PICKLEBALL: ["HARD", "CONCRETE", "CARPET"],
};

export function surfacesForSport(
  sport: string | undefined,
): readonly SurfaceKey[] {
  if (!sport) return [];
  return SPORT_SURFACES[sport as SportKey] ?? [];
}

// Court size/format. Mirror of SIZE_KEYS / SPORT_SIZES in
// packages/schemas/src/primitives.ts — only football distinguishes a court by
// player-count format.
export const SIZE_KEYS = [
  "FIVE_A_SIDE",
  "SIX_A_SIDE",
  "SEVEN_A_SIDE",
  "EIGHT_A_SIDE",
  "ELEVEN_A_SIDE",
  "FUTSAL",
] as const;
export type SizeKey = (typeof SIZE_KEYS)[number];

export const SPORT_SIZES: Record<SportKey, readonly SizeKey[]> = {
  TENNIS: [],
  PADEL: [],
  BASKETBALL: [],
  FOOTBALL: [
    "FIVE_A_SIDE",
    "SIX_A_SIDE",
    "SEVEN_A_SIDE",
    "EIGHT_A_SIDE",
    "ELEVEN_A_SIDE",
    "FUTSAL",
  ],
  VOLLEYBALL: [],
  SQUASH: [],
  TABLE_TENNIS: [],
  BADMINTON: [],
  HANDBALL: [],
  PICKLEBALL: [],
};

export function sizesForSport(sport: string | undefined): readonly SizeKey[] {
  if (!sport) return [];
  return SPORT_SIZES[sport as SportKey] ?? [];
}
